import React from 'react';
import {
  AppBar,
  CssBaseline,
  Toolbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from '@material-ui/core';
import './topNavBar.css';
import propTypes from 'prop-types';
import { codeFrameCodeShareUrlForParticipants, codeFrameURL, frontendUrl, publicJoinUrl } from '../../configFiles/config';
import frontEndConfigFile from '../../configFiles/frontendConfigFile';
import myAnatomyLogo from '../../images/myAnatomyLogo.png';
import IconButton from '@material-ui/core/IconButton';
import { BiCodeBlock } from 'react-icons/bi';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CastForEducationIcon from '@material-ui/icons/CastForEducation';
import InfoIcon from '@material-ui/icons/Info';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { theme } from '../../utils/uiTheme';
import { showSuccessToast } from '../../utils/toasts';
import ParticipantButtonWithBadge from '../ExternalVideoComponent/ParticipantButtonWithBadge';

class TopNavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openedCodeShareWindowForParticipant: [],
      openedNotesWindowForParticipant: [],
      openedWhiteboardWindowForParticipant: [],
      showMeetingDetailsDialog: false,
    };
  }

  componentDidUpdate(prevProps) {
    const prevIsRecording = prevProps.recordingStatus && prevProps.recordingStatus.isRecording === true;
    const currentRecordingStatus = this.props.recordingStatus || {};
    const currentIsRecording = currentRecordingStatus.isRecording === true;
    const currentStatusValue = currentRecordingStatus.status;

    if (prevIsRecording && !currentIsRecording && currentStatusValue === 'COMPLETED') {
      showSuccessToast('Recording has been stopped');
    }
  }

  openMeetingDetailsDialog = () => {
    this.setState({ showMeetingDetailsDialog: true });
  }

  closeMeetingDetailsDialog = () => {
    this.setState({ showMeetingDetailsDialog: false });
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.closeEventForCodeShareBoard);
    window.addEventListener('beforeunload', this.closeEventForNotesBoard);
    window.addEventListener('beforeunload', this.closeEventForWhiteboardBoard);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.closeEventForCodeShareBoard);
    window.removeEventListener('beforeunload', this.closeEventForNotesBoard);
    window.removeEventListener('beforeunload', this.closeEventForWhiteboardBoard);
  }

  closeEventForWhiteboardBoard = () => {
    const { openedWhiteboardWindowForParticipant } = this.state;

    openedWhiteboardWindowForParticipant.forEach((board) => {
      board.close();
    }
    );
    this.setState({
      openedWhiteboardWindowForParticipant: [],
    });
  }

  closeEventForNotesBoard = () => {
    const { openedNotesWindowForParticipant } = this.state;

    openedNotesWindowForParticipant.forEach((board) => {
      board.close();
    }
    );
    this.setState({
      openedNotesWindowForParticipant: [],
    });
  }

  closeEventForCodeShareBoard = () => {
    const {
      openedCodeShareWindowForParticipant,
    } = this.state;

    openedCodeShareWindowForParticipant.forEach((board) => {
      board.close();
    }
    );
    this.setState({
      openedCodeShareWindowForParticipant: [],
    });
  }

  showCodeShareBoard = () => {
    const {
      token,
      meetingId,
      externalMeetingId,
      name,
    } = this.props;
    let windowHeight = 440;
    let windowWidth = 630;

    let adjustFromTop = 0;

    const { openedCodeShareWindowForParticipant } = this.state;

    if (window.screen) {
      windowHeight = (window.screen.availHeight * 70) / 100;
      windowWidth = (window.screen.availWidth);
      adjustFromTop = (window.screen.availHeight * 15) / 100;
    }

    let codeShareURL = codeFrameCodeShareUrlForParticipants;

    codeShareURL = codeShareURL.replace('<<meetingId>>', meetingId);
    codeShareURL = codeShareURL.replace('<<meetingToken>>', token);
    codeShareURL = codeShareURL.replace('<<externalMeetingId>>', externalMeetingId);
    codeShareURL = codeShareURL.replace('<<participantName>>', name);
    const openWindow = window.open(
      codeShareURL,
      '_blank',
      `
          width=${windowWidth},
          height=${windowHeight},
          top=${adjustFromTop},
          location=no,
        `
    );

    openedCodeShareWindowForParticipant.push(openWindow);

    this.setState({
      openedCodeShareWindowForParticipant,
    });
  }

  showNotesView = () => {
    let windowHeight = 440;
    let windowWidth = 630;

    let adjustFromTop = 0;

    const { openedNotesWindowForParticipant } = this.state;

    if (window.screen) {
      windowHeight = (window.screen.availHeight * 70) / 100;
      windowWidth = (window.screen.availWidth);
      adjustFromTop = (window.screen.availHeight * 15) / 100;
    }

    let codeframeUrl = frontEndConfigFile.CODE_FRAME_URL.frontend;
    codeframeUrl = codeframeUrl.replace(/<<codeFrameConfigUrl>>/g, codeFrameURL);

    let notesViewUrl = frontEndConfigFile.NOTES.url;
    notesViewUrl = notesViewUrl.replace('<<codeFrameUrl>>', codeframeUrl);
    //let notesViewUrl = 'https://codeframe.myanatomy.in/';
    const openWindow = window.open(
      notesViewUrl,
      '_blank',
      `
          width=${windowWidth},
          height=${windowHeight},
          top=${adjustFromTop},
          location=no,
        `
    );

    openedNotesWindowForParticipant.push(openWindow);

    this.setState({
      openedNotesWindowForParticipant,
    });
  }

  showWhiteboardView = () => {
    let windowHeight = 440;
    let windowWidth = 630;

    let adjustFromTop = 0;

    const { openedWhiteboardWindowForParticipant } = this.state;

    if (window.screen) {
      windowHeight = (window.screen.availHeight * 70) / 100;
      windowWidth = (window.screen.availWidth);
      adjustFromTop = (window.screen.availHeight * 15) / 100;
    }
    const { externalMeetingId } = this.props;
    //  * -----Uncomment the below lines after integration when getting purpose and client id and pass the url--- *
    let codeframeUrl = frontEndConfigFile.CODE_FRAME_URL.frontend;
    codeframeUrl = codeframeUrl.replace(/<<codeFrameConfigUrl>>/g, codeFrameURL);

    let whiteBoardUrl = frontEndConfigFile.WHITEBOARD.url;
    whiteBoardUrl = whiteBoardUrl.replace('<<codeFrameUrl>>', codeframeUrl);
    whiteBoardUrl = whiteBoardUrl.replace('<<purposeId>>', externalMeetingId);
    whiteBoardUrl = whiteBoardUrl.replace('<<clientId>>', '');

    const openWindow = window.open(
      whiteBoardUrl,
      '_blank',
      `
            width=${windowWidth},
            height=${windowHeight},
            top=${adjustFromTop},
            location=no,
          `
    );

    openedWhiteboardWindowForParticipant.push(openWindow);

    this.setState({
      openedWhiteboardWindowForParticipant,
    });
  }

  render() {

    const {
      hasMeetingStarted,
      hasMeetingEnded,
      isPasswordAccessEnabled,
      isPasswordVerified,
      meetingTitle,
      meetingId,
      raisedHandCount,
      recordingStatus,
    } = this.props;

    const { showMeetingDetailsDialog } = this.state;

    const recordingStatusObj = recordingStatus || {};
    const recordingStatusValue = recordingStatusObj.status;
    const isRecording = recordingStatusObj.isRecording === true;
    const isStopping = !isRecording && recordingStatusValue === 'STOPPING';
    // Combine frontendUrl and publicJoinUrl, ensuring no double slashes if needed, or just simple concatenation
    // Assuming publicJoinUrl is a path like '/join/...'
    let inviteLink = (frontendUrl && publicJoinUrl) ? `${frontendUrl}${publicJoinUrl.replace('<<meetingId>>', meetingId)}` : '';

    return (
      <div>
        <CssBaseline />
        <AppBar
          style={{
            background: theme.primary1Color,
            height: '50px',
          }}
          position="fixed"
        >
          <Toolbar style={{ justifyContent: 'space-between', position: 'relative' }}>
            <div className='company'>
              <div className='company-logo'>
                <a href='https://myanatomy.in/#/home' target='_blank' rel='noopener noreferrer'><img className='navbarLogoWidth' src={myAnatomyLogo} alt='MA' /></a>
              </div>
            </div>

            {/* Centered Meeting Title */}
            <Typography
              variant="h6"
              style={{
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
                color: 'white',
                fontWeight: 'bold',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '50%'
              }}
              title={meetingTitle}
            >
              {meetingTitle}
            </Typography>

            <div style={{ display: 'flex', alignItems: 'center' }}>

              {/* Recording Indicator */}
              {isRecording && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginRight: '16px',
                    color: 'red',
                    fontWeight: 'bold',
                  }}
                >
                  <FiberManualRecordIcon style={{ fontSize: '14px', marginRight: '4px' }} />
                  <Typography variant="body2">REC</Typography>
                </div>
              )}

              {!isRecording && isStopping && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginRight: '16px',
                    color: 'orange',
                    fontWeight: 'bold',
                  }}
                >
                  <Typography variant="body2">Stopping...</Typography>
                </div>
              )}

              {hasMeetingStarted && !hasMeetingEnded && ((isPasswordAccessEnabled && isPasswordVerified) || (!isPasswordAccessEnabled)) ?
                <div className='infoOption'>
                  <IconButton
                    style={{ color: 'white' }}
                    title='Meeting Info'
                    onClick={this.openMeetingDetailsDialog}
                  >
                    <InfoIcon />
                  </IconButton>
                </div>
                : null
              }
              {hasMeetingStarted && !hasMeetingEnded && ((isPasswordAccessEnabled && isPasswordVerified) || (!isPasswordAccessEnabled)) ?
                <div className='participantsOption'>
                  <ParticipantButtonWithBadge
                    style={{ color: 'white' }}
                    title='Participants'
                    onClick={this.props.toggleParticipants}
                    count={raisedHandCount}
                  />
                </div>
                : null
              }
              {hasMeetingStarted && !hasMeetingEnded && ((isPasswordAccessEnabled && isPasswordVerified) || (!isPasswordAccessEnabled)) ?
                <div className='codeShareOption'>
                  <IconButton
                    style={{
                      color: 'white',
                    }}
                    title='Open code share board'
                    onClick={() => { this.showCodeShareBoard(); }}
                  >
                    <BiCodeBlock />
                  </IconButton>
                </div>
                :
                null
              }
              {hasMeetingStarted && !hasMeetingEnded && ((isPasswordAccessEnabled && isPasswordVerified) || (!isPasswordAccessEnabled)) ?
                <div className='notesOption'>
                  <IconButton
                    style={{
                      color: 'white',
                    }}
                    title='Take Notes'
                    onClick={() => { this.showNotesView(); }}
                  >
                    <AssignmentIcon />
                  </IconButton>
                </div>
                :
                null
              }
              {hasMeetingStarted && !hasMeetingEnded && ((isPasswordAccessEnabled && isPasswordVerified) || (!isPasswordAccessEnabled)) ?
                <div className='whiteboardOption'>
                  <IconButton
                    style={{
                      color: 'white',
                    }}
                    title='Open Whiteboard'
                    onClick={() => { this.showWhiteboardView(); }}
                  >
                    <CastForEducationIcon />
                  </IconButton>
                </div>
                :
                null
              }
            </div>
          </Toolbar>
        </AppBar>
        <Dialog open={showMeetingDetailsDialog} onClose={this.closeMeetingDetailsDialog} fullWidth maxWidth="sm">
          <DialogTitle>Meeting Details</DialogTitle>
          <DialogContent dividers>
            <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 'bold' }}>
              Meeting Name:
            </Typography>
            <Typography variant="body1" gutterBottom>
              {meetingTitle || 'No Title'}
            </Typography>

            <div style={{ marginTop: '20px' }}>
              <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 'bold' }}>
                Invite Link:
              </Typography>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  value={inviteLink}
                  InputProps={{
                    readOnly: true,
                  }}
                  size="small"
                />
                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginLeft: '10px' }}
                  onClick={() => {
                    navigator.clipboard.writeText(inviteLink);
                    showSuccessToast('Invite link copied successfully');
                  }}
                >
                  Copy
                </Button>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={this.closeMeetingDetailsDialog} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

TopNavBar.propTypes = {
  meetingId: propTypes.string,
  token: propTypes.string,
  hasMeetingStarted: propTypes.bool,
  hasMeetingEnded: propTypes.bool,
  externalMeetingId: propTypes.string,
  name: propTypes.string,
  isPasswordAccessEnabled: propTypes.bool,
  isPasswordVerified: propTypes.bool,
  toggleParticipants: propTypes.func,
  raisedHandCount: propTypes.number,
  recordingStatus: propTypes.object,
};

export default TopNavBar;
